// extracted by mini-css-extract-plugin
export default {"image":"nodata_image__vjrKR","heading":"nodata_heading__K0I+P","paragraph":"nodata_paragraph__rkV+R"};